import React, { Button, Dialog, Grid, Typography, useTheme } from "@mui/material";
import { DocumentViewerContainer, LandingContentActions, LandingContentContainer } from "./styles";
import { ALERT_LINE_PAGE } from "./AlertLinePage";
import { useCallback, useEffect, useState } from "react";
import Recaptcha from "../../../containers/Recaptcha/Recaptcha";
import { IFile } from "../../../reusable-components/DocumentViewer/interfaces";
import { AlertLineURLDTO } from "../../../models/alert-line-url/alert-line-url-dto";
import DocumentViewer from "../../../reusable-components/DocumentViewer/DocumentViewer";
import DialogTitle from "../../../containers/DialogTitle/DialogTitle";
import { RECAPTCHA_ACTIONS } from "../../../utils/constants/recaptcha-actions";
import LoadingOverlay from "../../../containers/LoadingOverlay/LoadingOverlay";
import { AlertLineURLLanguageVersionRef } from "../../../models/alert-line-url/alert-line-url-language-version-ref";
import { useTranslation } from "react-i18next";
import { DocumentRef } from "../../../models/documents";
import AttachedDocuments from "../../../containers/AttachedDocuments/AttachedDocuments";
import { DocumentFileDTO } from "../../../models/documents/document-files";
interface Props {
  alertLineURL: AlertLineURLDTO;
  handleChangeView: (view: ALERT_LINE_PAGE) => void;
  selectedLanguage: AlertLineURLLanguageVersionRef;
}
interface State {
  verifyingRecaptcha: boolean;
  viewFile: DocumentFileDTO | null;
  policyDocumentLink: string;
  policyDocIFiles: IFile[];
  documentmOneIFiles: IFile[];
  documentTwoIFiles: IFile[];
  documentOneLink: string;
  documentTwoLink: string;
  loading: boolean;
  error: string;
  docOne: DocumentRef | null;
  docTwo: DocumentRef | null;
  policyDoc: DocumentRef | null;
}
const AlertLineLanding = ({ alertLineURL, handleChangeView, selectedLanguage }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const tRP = "pages.alert_line_report";
  const [state, setState] = useState<State>({
    verifyingRecaptcha: false,
    viewFile: null,
    policyDocumentLink: "",
    policyDocIFiles: [],
    documentmOneIFiles: [],
    documentOneLink: "",
    documentTwoLink: "",
    documentTwoIFiles: [],
    loading: false,
    error: "",
    docOne: null,
    docTwo: null,
    policyDoc: null,
  });

  //#region recaptcha response
  const handleRecaptchaResponse = useCallback(
    (verfied: boolean, targetView: ALERT_LINE_PAGE) => {
      if (verfied) {
        handleChangeView(targetView ?? ALERT_LINE_PAGE.LandingPage);
      } else {
        alert(`${t(`${tRP}.recaptcha_not_verified`)}`);
      }
    },
    [handleChangeView]
  );
  //#endregion

  //#region documanet links
  const handleDocumentLinks = useCallback(() => {
    if (selectedLanguage) {
      const policyDocRegex = /\{\{policyDocument:(.*?)\}\}/g;
      const docOneRegex = /\{\{documentOne:(.*?)\}\}/g;
      const docTwoRegex = /\{\{documentTwo:(.*?)\}\}/g;

      const policyDocumentLink = policyDocRegex.exec(selectedLanguage?.description);
      const docOneLink = docOneRegex.exec(selectedLanguage?.description);
      const docTwoLink = docTwoRegex.exec(selectedLanguage?.description);

      setState((state) => ({
        ...state,
        policyDocumentLink: policyDocumentLink ? policyDocumentLink[1] : "",
        documentOneLink: docOneLink ? docOneLink[1] : "",
        documentTwoLink: docTwoLink ? docTwoLink[1] : "",
      }));
    }
  }, [selectedLanguage]);
  //#endregion

  //#region check for docs
  const checkForDocs = useCallback(() => {
    const docOne = selectedLanguage?.files?.find((file) => file.isDocumentOne)?.document ?? null;
    const docTwo = selectedLanguage?.files?.find((file) => file.isDocumentTwo)?.document ?? null;
    const policyDoc = selectedLanguage?.files?.find((file) => file.isPolicyDoc)?.document ?? null;

    setState((state) => ({
      ...state,
      docOne: docOne,
      docTwo: docTwo,
      policyDoc: policyDoc,
    }));
  }, [selectedLanguage]);
  //#endregion

  useEffect(() => {
    handleDocumentLinks();
    checkForDocs();
  }, [alertLineURL, selectedLanguage]);

  //#region get doc file
  const getDocFile = useCallback((file: IFile) => {}, []);
  //#endregion

  return (
    <>
      <LoadingOverlay
        loading={state.loading}
        error={state.error}
      >
        <LandingContentContainer>
          <span>
            <>
              {selectedLanguage?.description.split(/\{\{policyDocument.*?\}\}/g)[0]}

              {state.policyDoc?.files[0] ? (
                <Button
                  onClick={() =>
                    setState((state) => ({
                      ...state,
                      viewFile: state.policyDoc!.files[0],
                    }))
                  }
                  style={{ textTransform: "none", padding: "0px" }}
                >
                  {state.policyDocumentLink}
                </Button>
              ) : (
                <span
                  style={{
                    color: theme.palette.primary.main,
                  }}
                >
                  {state.policyDocumentLink}
                </span>
              )}
            </>

            <>
              {
                selectedLanguage?.description
                  .split(/\{\{policyDocument.*?\}\}/g)[1]
                  ?.split(/\{\{documentOne.*?\}\}/g)[0]
              }

              {state.docOne?.files[0] ? (
                <Button
                  onClick={() =>
                    setState((state) => ({
                      ...state,
                      viewFile: state.docOne!.files[0],
                    }))
                  }
                  style={{ textTransform: "none", padding: "0px" }}
                >
                  {state.documentOneLink}
                </Button>
              ) : (
                <span
                  style={{
                    color: theme.palette.primary.main,
                  }}
                >
                  {state.documentOneLink}
                </span>
              )}
            </>

            <>
              {selectedLanguage?.description.split(/\{\{documentOne.*?\}\}/g)[1]?.split(/\{\{documentTwo.*?\}\}/g)[0]}

              {state.docTwo?.files[0] ? (
                <Button
                  onClick={() =>
                    setState((state) => ({
                      ...state,
                      viewFile: state.docTwo!.files[0],
                    }))
                  }
                  style={{ textTransform: "none", padding: "0px" }}
                >
                  {state.documentTwoLink}
                </Button>
              ) : (
                <span
                  style={{
                    color: theme.palette.primary.main,
                  }}
                >
                  {state.documentTwoLink}
                </span>
              )}
            </>
          </span>
          <LandingContentActions>
            <Recaptcha
              action={RECAPTCHA_ACTIONS.addAlertLineReport}
              notifyParent={(verified: boolean) => handleRecaptchaResponse(verified, ALERT_LINE_PAGE.NewReport)}
              setLoading={(loading: boolean) => setState((state) => ({ ...state, loading }))}
            >
              <Typography
                style={{
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.primary.contrastText,
                  padding: "10px",
                  borderRadius: "5px",
                }}
              >
                {`${t(`${tRP}.add_new_report`)}`}
              </Typography>
            </Recaptcha>
            <Recaptcha
              action={RECAPTCHA_ACTIONS.addAlertLineReport}
              notifyParent={(verified: boolean) => handleRecaptchaResponse(verified, ALERT_LINE_PAGE.PreviousReport)}
              setLoading={(loading: boolean) => setState((state) => ({ ...state, loading }))}
            >
              <Typography
                style={{
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.primary.contrastText,
                  padding: "10px",
                  borderRadius: "5px",
                }}
              >
                {`${t(`${tRP}.check_previous_report`)}`}
              </Typography>
            </Recaptcha>
          </LandingContentActions>
        </LandingContentContainer>
      </LoadingOverlay>

      <DocumentViewerContainer
        open={!!state.viewFile}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle
          title=""
          handleClose={() => setState((state) => ({ ...state, viewFile: null }))}
        />
        <Grid style={{ width: "90vw" }}>
          {state.viewFile && (
            <DocumentViewer
              fileDto={state.viewFile}
              withFooter
              isGenericDocument
            />
          )}
        </Grid>
      </DocumentViewerContainer>
    </>
  );
};
export default AlertLineLanding;
